export default "__VITE_ASSET__CV$53FA1__"